/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgSpinner = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M8 2a6 6 0 1 1-5.24 3.075L1.014 4.1A8 8 0 1 0 8 0v2z' />
  </svg>
)
export default SvgSpinner
